import Header from "components/Header";
import React, { useState, useEffect } from "react";
import { goToTop } from "helpers/helpers";
import Step1 from "pages/Steps/Step1";
import Step2 from "pages/Steps/Step2";
import Step3 from "pages/Steps/Step3";
import Step4 from "pages/Steps/Step4";
import Step5 from "pages/Steps/Step5";
import Step6 from "pages/Steps/Step6";
import Step7 from "pages/Steps/Step7";
import Step8 from "pages/Steps/Step8";
import Step9 from "pages/Steps/Step9";
import Step10 from "pages/Steps/Step10";
import objectsSchema from "schemas/objectsSchema";
import { RotatingTriangles } from "react-loader-spinner";
import {toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RequestMethod, requestJson } from "helpers/httpHelper";
import { prepareDataCheckStatus } from "helpers/PrepareData";


export default function ContractFormClientiCasnici() {
   const [currentStep, setCurrentStep] = useState(1);
   const [loading, setLoading] = useState(false);
   const [redirectFinalStep, setRedirectFinalStep] = useState("");
   const [firstSubmit, setFirstSubmit] = useState(false);
   const defaultStepState = {
      sessionStartedAt: new Date(),
      step1: { judet: "", localitate: "", codSIRUTA: "" },
      step2: { cod: "", oferte: [] },
      step3: {
         tipCetatenie: "",
         nif: "", //Cetatean_STRAIN
         tara: "", //Cetatean_STRAIN
         prenume: "",
         nume: "",
         email: "",
         emailConfirm: "",
         telefon: "",
         cnp: "",
         semnatura: "",
         newsletter: false,
         analytics: false,
      },
      opportunityId: "",
      step4: {
         beneficieziInPrezent: "",
         schimbiTitular: "",
         premierEnergyTitular: "",
         furnizorActual: "",
         esteBransat: "",
         isPIF: false,
         fileFacturaPIF: null,
         fileDovadaPlata: null,
      },
      step5: {
         fileCI: null, //Cetatean_ROMAN
         fileNIF: null, //Cetatean_STRAIN
         filePermisSedere: null, //Cetatean_STRAIN
         filePasaport: null, //Cetatean_STRAIN
         fileAlteDocumente: null, //Cetatean_STRAIN
      },
      step6: {
         nif: "", //Cetatean_STRAIN
         nrPasaport: "", //Cetatean_STRAIN
         emisLaPasaport: "", //Cetatean_STRAIN
         expiraLaPasaport: "", //Cetatean_STRAIN
         taraEmitenta: "", //Cetatean_STRAIN
         nume: "",
         prenume: "",
         serieCI: "", //Cetatean_ROMAN
         numarCI: "", //Cetatean_ROMAN
         emisDeCI: "", //Cetatean_ROMAN
         emisLaCI: "", //Cetatean_ROMAN
         expiraLaCI: "", //Cetatean_ROMAN
         cnp: "", //Cetatean_ROMAN
         domiciliu: objectsSchema.adresaSchema,
         telefon: "",
         email: "",
         adresaConsumDomiciliu: false,
         consum: objectsSchema.adresaSchema,
         facturaMail: true,
         corespondenta: objectsSchema.adresaSchema,
      },
      step7: { fileCLCPOD: null },
      step8: {
         calitateDetinator: "",
         valabilitateChirie: "",
         fileCoProprietar: [],
         scopConsum: true,
         unitateMasura: "m3",
         categorieConsum: "C1",
         indexLuni: objectsSchema.indexLuniSchemaC1,
         sumOfIndexLuni: 0,
         acordConventieConsum: false,
         indexContorManual: "",
         indexContorPhoto: null,
         dataLivrare: "",
         pod: "",
      },
      // step9: { pdfViewed: false },
      step10: {},
   }

   const [stepsState, setAllStepsState] = useState(defaultStepState);

   //functie care salveaza si seteaza state-ul pentru fiecare pas
   const persistState = async funct => {
      const prevState = stepsState;
      const data = funct(prevState);
      localStorage.setItem("sessionStepsState", JSON.stringify(data));
      setAllStepsState(funct);
   };

   const isOpportunityStatusValid = async opportunityId => {
      if (opportunityId === undefined || opportunityId === null) {
         console.log('opportunityId is undefined or null');
         toast.error("Va rugam sa incercati din nou.");
         return false;
      }
      const response = await requestJson(process.env["REACT_APP_API_ENDPOINT_B2C_CHECK_STATUS"], RequestMethod.POST,
         { data: prepareDataCheckStatus(opportunityId) });

      return response.isSuccess && response.response.status === "Activ";
   };

   //functie care verifica daca opportunityId-ul din localStorage este activ si daca nu este activ, sterge datele din localStorage
   const handleLocalStorageAfterCheckStatus = async (sessionStepsState) => {
      //afiseaa loading-ul
      setLoading(true);
      const statusOpportunity = await isOpportunityStatusValid(sessionStepsState.opportunityId);

      if(!statusOpportunity) {
         localStorage.removeItem("sessionStepsState");
         localStorage.removeItem("sessionCurrentStep");
         setCurrentStep(1);
         setAllStepsState(defaultStepState);
         goToTop();

         setLoading(false);
         return false;
      }

      setLoading(false);
      return true;
   }

   //verific daca exista un opportunityId in localStorage si daca da, verific daca este activ si daca da, setez state-ul cu datele din localStorage
   // si setez currentStep cu valoarea din localStorage
   useEffect(() => {
      const sessionStepsState = JSON.parse(localStorage.getItem("sessionStepsState"));
      const step = parseInt(localStorage.getItem("sessionCurrentStep"));

      if (sessionStepsState?.sessionStartedAt) {
         const timeElapsedInSeconds = (new Date() - new Date(sessionStepsState?.sessionStartedAt)) / 1000;
         const timeElapsedInHours = timeElapsedInSeconds / 3600;
         if (timeElapsedInHours >= 120) {
            localStorage.removeItem("sessionStepsState");
            localStorage.removeItem("sessionCurrentStep");
            goToTop();
            return;
         }   else if(sessionStepsState?.opportunityId){
            handleLocalStorageAfterCheckStatus(sessionStepsState);
         }
      }

      if (localStorage.getItem("sessionCurrentStep") !== null) {
         setCurrentStep(step);
      }
      if (sessionStepsState) setAllStepsState(sessionStepsState);
   }, []);

   //daca loading === true nu poti face scroll
   useEffect(() => {
      if (loading) {
         document.body.style.overflow = "hidden";
      } else {
         document.body.style.overflow = "auto";
      }
   }, [loading]);

   return (
      <>
         <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
         />
         <RotatingTriangles
            visible={loading}
            colors={["#34c687", "#ff9241", "#1e456d"]}
            height="100vh"
            width="100%"
            ariaLabel="rotating-triangels-loading"
            wrapperStyle={{
               justifyContent: "center",
               alignItems: "center",
               position: "absolute",
               zIndex: "100",
               backgroundColor: "rgba(0,0,0,0.5)",
               minHeight: "120vh",
            }}
            wrapperClass="rotating-triangels-wrapper"
         />
         <Header currentStep={currentStep} setCurrentStep={setCurrentStep} />

         {(() => {
            switch (currentStep) {
               case 1:
                  return (
                     <Step1
                        stepsState={stepsState.step1}
                        persistState={persistState}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        setLoading={setLoading}
                        firstSubmit={firstSubmit}
                        setFirstSubmit={setFirstSubmit}
                     />
                  );
               case 2:
                  return (
                     <Step2 stepsState={stepsState.step2} persistState={persistState} currentStep={currentStep} setCurrentStep={setCurrentStep} />
                  );
               case 3:
                  return (
                     <Step3
                        stepsState={{ step1: stepsState.step1, step2: stepsState.step2, step3: stepsState.step3 }}
                        persistState={persistState}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        setLoading={setLoading}
                        setRedirectFinalStep={setRedirectFinalStep}
                        firstSubmit={firstSubmit}
                        setFirstSubmit={setFirstSubmit}
                     />
                  );
               case 4:
                  return (
                     <Step4
                        stepsState={{ step4: stepsState.step4, opportunityId: stepsState.opportunityId }}
                        persistState={persistState}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        setLoading={setLoading}
                        setRedirectFinalStep={setRedirectFinalStep}
                        firstSubmit={firstSubmit}
                        setFirstSubmit={setFirstSubmit}
                     />
                  );
               case 5:
                  return (
                     <Step5
                        stepsState={{ step5: stepsState.step5, opportunityId: stepsState.opportunityId }}
                        persistState={persistState}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        tipCetatenie={stepsState.step3.tipCetatenie}
                     />
                  );
               case 6:
                  return (
                     <Step6
                        stepsState={{ step3: stepsState.step3, step6: stepsState.step6, opportunityId: stepsState.opportunityId, step2: stepsState.step2}}
                        persistState={persistState}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        setLoading={setLoading}
                        firstSubmit={firstSubmit}
                        setFirstSubmit={setFirstSubmit}
                        tipCetatenie={stepsState.step3.tipCetatenie}
                     />
                  );
               case 7:
                  return (
                     <Step7
                        stepsState={{ step7: stepsState.step7, opportunityId: stepsState.opportunityId, step4: stepsState.step4 }}
                        persistState={persistState}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        setLoading={setLoading}
                     />
                  );
               case 8:
                  return (
                     <Step8
                        stepsState={{ step8: stepsState.step8, step4: stepsState.step4, step6: stepsState.step6, opportunityId: stepsState.opportunityId }}
                        persistState={persistState}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        setLoading={setLoading}
                        firstSubmit={firstSubmit}
                        setFirstSubmit={setFirstSubmit}
                     />
                  );
               case 9:
                  return (
                     <Step9
                        stepsState={{ opportunityId: stepsState.opportunityId }}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        setLoading={setLoading}
                     />
                  );
               case 10:
                  return <Step10 redirectFinalStep={redirectFinalStep} />;
               default:
                  return <Step1 />;
            }
         })()}
      </>
   );
}